"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var action_button_scss_1 = tslib_1.__importDefault(require("./action-button.scss"));
var ActionButton = /** @class */ (function (_super) {
    tslib_1.__extends(ActionButton, _super);
    function ActionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionButton.prototype.render = function () {
        var _a;
        var _b = this.props, rounded = _b.rounded, children = _b.children, className = _b.className, onClick = _b.onClick, isFocusable = _b.isFocusable, ariaLabel = _b.ariaLabel, dataHook = _b.dataHook;
        var styleNames = (0, classnames_1.default)(className, action_button_scss_1.default['action-button'], (_a = {},
            _a[action_button_scss_1.default.rounded] = rounded,
            _a));
        return (react_1.default.createElement("button", { className: styleNames, onClick: onClick, tabIndex: onClick && isFocusable ? 0 : -1, "data-hook": dataHook, "aria-label": ariaLabel }, children));
    };
    ActionButton.defaultProps = {
        rounded: false,
        isFocusable: true,
    };
    return ActionButton;
}(react_1.default.Component));
exports.default = ActionButton;
//# sourceMappingURL=action-button.js.map